import { Icon } from '~/models/common/types'
import { ciBox } from '~/icons/source/regular/box'
import { ciNew } from '~/icons/source/regular/new'

export const conditionKeyFeaturesIcons: {
  [name: string]: Icon
} = Object.freeze({
  used: {
    icon: ciBox
  },
  new: {
    icon: ciNew
  }
})
